const healthProfessionalInformationSchema = {
    professionalCivilName: {
    displayName: 'Nome do profissional',
    notAvailable: 'Nome não informado',


  },
  professionalSocialName: {
    displayName: 'Nome social do profissional',
    notAvailable: 'Nome social não informado',
  },
  professionalCns: {
    displayName: 'CNS do profissional',
    notAvailable: 'CNS não informado',
    mask: 'cns',

  },
  professionalCbo: {
    displayName: 'CBO do profissional',
    notAvailable: 'CBO não informado',

  },
  professionalSex: {
    displayName: 'Sexo do profissional',
    notAvailable: 'Sexo não informado',
    mask: 'sex',

  },
  professionalBirthDate: {
    displayName: 'Data de nascimento do profissional',
    notAvailable: 'Data de nascimento não informada',

  },
  professionalPhoneNumber: {
    displayName: 'Número de telefone do profissional',
    notAvailable: 'Número de telefone não informado',
    mask: 'phone',

  },
  professionalTeamIne: {
    displayName: 'Equipe de saúde',
    notAvailable: 'Equipe de saúde não informada',

  },
}

export default healthProfessionalInformationSchema
